/**
 * @fileoverview GET handler for the "/app_settings/:app_group_id/message_prioritization/category/:category_id/dependencies" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdDependencies } from "./constants";
import type { GetMessagePrioritizationCategoryDependenciesResult } from "./types";
import { isGetMessagePrioritizationCategoryDependenciesResult } from "./validators";

export const getMessagePrioritizationCategoryDependencies = reactQueryFetcherAdapter(
  appSettingsAppGroupIdMessagePrioritizationCategoryCategoryIdDependencies,
  (
    signal: AbortSignal,
    appGroupId: string,
    categoryId: string
  ): Promise<GetMessagePrioritizationCategoryDependenciesResult> => {
    return fetch(
      `/app_settings/${appGroupId}/message_prioritization/category/${categoryId}/dependencies`,
      "GET",
      {},
      { signal },
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  },
  isGetMessagePrioritizationCategoryDependenciesResult
);
